import PropTypes from 'prop-types';
import React from 'react';

const NoMatch = ({location}) => (
  <section className='mw7 center pt4 ph3'>
    <h4>Page Not Found</h4>
    <p>No match for <code>{location.pathname}</code></p>
  </section>
)

NoMatch.propTypes = {
  location: PropTypes.object.isRequired
}

export default NoMatch
